import { push } from 'react-router-redux';
import { createActions } from 'redux-actions';
import { put } from 'redux-saga/effects';

const action = createActions({
  ONBOARDING: {
    SELECT_CPD_CATEGORYS: (cpdCategorys, nextRoute) => ({ cpdCategorys, nextRoute })
  }
})

export function* selectCpdCategorys({ payload }) {
  const { nextRoute } = payload;
  if (nextRoute) {
    yield put(push({ pathname: nextRoute }));
  }
}

const configuration = {
  name: 'selectCpdCategorys',
  action: action,
  sagas: selectCpdCategorys,
  reducers: {
    reducer: (state, action) => ({
      ...state,
      onboarding: {
        ...state.onboarding,
        selectedCpdCategorys: action.payload.cpdCategorys
      }
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/global/configurations/selectCpdCategorys.js